var render = function () {
  var _vm$pdm;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('custom-container', [_c('custom-container', {
    attrs: {
      "id": "snapshot-image-scene"
    }
  }), _c('custom-container', {
    staticClass: "buy-panel-product-image--container"
  }, [_c('base-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSpinner,
      expression: "showSpinner"
    }]
  }), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showSpinner,
      expression: "!showSpinner"
    }],
    ref: "productImage",
    class: ['buy-panel-product-image-model-image', {
      'buy-panel-product-image-model-image--apparel': _vm.isApparel
    }],
    attrs: {
      "src": "",
      "alt": (_vm$pdm = _vm.pdm) === null || _vm$pdm === void 0 ? void 0 : _vm$pdm.product_name
    },
    on: {
      "load": _vm.hideSpinner
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }